<template>
  <div class="organization">
    <a-layout>
      <a-layout-sider>
        <mTree @childVal='childVal' @engVal='engVal'/>
      </a-layout-sider>
      <a-layout-content>
        <a-row :gutter="24">
          <a-form
            :labelAlign="labelAlign"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            layout="inline"
          >
            <a-row>
              <a-col :span="7">
                <a-button type="primary" @click="showModal">
                  添加人员
                </a-button>
                <a-modal ref="addFormP" v-model="visible" v-if="visible" title="添加人员" on-ok="handleOk">
                  <template slot="footer">
                    <a-button key="back" @click="handleCancel">
                      取消
                    </a-button>
                    <a-button key="submit" type="primary" :loading="loading" @click="handleOk">
                      确定
                    </a-button>
                  </template>
                    <template>
                      <a-form :label-col="labelCol">
                        <a-form-item label="组织类型：">
                          <a-input v-model="zzType" allow-clear/>
                        </a-form-item>
                        <a-form-item label="归属组织：">
                          <a-input v-model="zzName" allow-clear/>
                        </a-form-item>
                        <a-form-item label="人员选择：">
                          <a-select
                            mode="multiple"
                            style="width: 100%"
                            @change="handleChange"
                          >
                            <a-select-option v-for="item in userOrgList" :key="item.id" :value="item.id">
                              {{item.name}}  <span style="margin-left: 10px;font-size: 10px;">({{item.companyName}})</span>
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-form>
                    </template>
                </a-modal>
                <a-button type="primary" @click="delOrgUsers">
                  删除
                </a-button>
                <a-button type="primary" @click="getListEngineers">
                  查询
                </a-button>
                <a-button type="primary" @click="showModalData">
                  添加授权
                </a-button>
                 <a-popconfirm
                  title="是否确定清除授权？"
                  @confirm="() => clearOk()"
                >
                 <a-button type="primary">
                  清除授权
                </a-button>
                </a-popconfirm>

                <a-modal v-model="visibleData" title="数据授权" width="560px" on-ok="handleOkData">
                  <template slot="footer">
                    <a-button key="back" @click="handleCancelData">
                      取消
                    </a-button>
                    <a-button key="submit" type="primary" :loading="loadingData" @click="handleOkData">
                      确定
                    </a-button>
                  </template>
                  <div>
                    <div class="auth-switch-row">
                      <span>是否选择其他项目：</span>
                      <a-switch size="small" :checked="authShowAllEng" @change="onAuthModeChange" />
                    </div>
                    <template v-if="!authShowAllEng">
                      <div :style="{ borderBottom: '1px solid #E9E9E9' }">
                        <a-checkbox :indeterminate="authIndeterminate" :checked="authCheckAll" @change="onAuthCheckAllChange">
                          全部
                        </a-checkbox>
                      </div>
                      <br />
                      <a-checkbox-group class="auth-checkbox-list" v-model="authCheckedList" :options="authOrgOptions" @change="onAuthCheckedListChange" />
                    </template>
                    <template v-else>
                      <a-input-search
                        placeholder="请输入组织机构名称搜索"
                        v-model="authSearchVal"
                        allow-clear
                        @search="onAuthSearch"
                        style="margin-bottom: 8px"
                      />
                      <div :style="{ borderBottom: '1px solid #E9E9E9' }">
                        <a-checkbox :indeterminate="indeterminateData" :checked="checkAllData" @change="onCheckAllAuthData">
                          全部
                        </a-checkbox>
                      </div>
                      <div class="auth-tree-box">
                        <a-tree
                          checkable
                          :tree-data="filteredAuthTreeData"
                          :expanded-keys="authExpandedKeys"
                          :checked-keys="authCheckedKeys"
                          @expand="onAuthExpand"
                          @check="onCheckAuthData"
                        />
                      </div>
                    </template>
                  </div>
                </a-modal>
              </a-col>
            </a-row>
          </a-form>
        </a-row>
        <a-card>

          <a-table
            :row-selection="rowSelection"
            :pagination="pagination"
            @change="handleTableChange"
            :columns="columns"
            :data-source="data"
            :bordered='true'
            :scroll="{ y: 'calc(100vh - 190px)'}"
          >
            <template slot="roles" slot-scope="text, record">
              <div class="roles-box">
                <span v-if="record.roleList && record.roleList.length">
                  <span v-for="(r, i) in record.roleList" :key="i">
                    <a-tooltip :title="r.engName">
                      <span>{{ r.orgName }}</span>
                    </a-tooltip><span v-if="i < record.roleList.length - 1">,</span>
                  </span>
                </span>
                <div class="roles-ops">
                  <a @click="showEditAuth(record)">编辑权限</a>
                </div>
              </div>
            </template>
          </a-table>
        </a-card>
      </a-layout-content>
    </a-layout>
  </div>
</template>
<script>
import mix from "./Organization-mixins";
import mTree from "@/components/mTreeComplex.vue";
export default {
  mixins: [mix],
  components: { mTree }
};
</script>
<style lang="less" scoped>
@import "./Organization.less";
</style>
<style lang="less">
// 数据授权弹窗（挂在 body 下，需全局样式）
.auth-switch-row {
  margin-bottom: 8px;
}
.auth-checkbox-list {
  flex-direction: column;
  display: flex;
  max-height: 50vh;
  overflow-y: auto;
}
.auth-tree-box {
  margin-top: 8px;
  max-height: 50vh;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Organization/Organization.vue